import Spotify from "../../../../src/components/spotify";
import Comments from "../../../../src/components/comments";
import * as React from 'react';
export default {
  Spotify,
  Comments,
  React
};